exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user-widget[data-v-63982f4c]{display:inline-block}.user-widget_image[data-v-63982f4c]{display:inline-block;width:20px;height:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-63982f4c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SymbolCell.vue
// module id = 77
// module chunks = 0